enum DonationsSortFields {
  CAMPAIGN_NAME = 'campaign_name',
  DISPLAY_NAME = 'display_name',
  DONATION_DATE = 'donation_date',
  DONATION_TYPE = 'donation_type',
  PAYMENT_TYPE = 'payment_type',
}

export default DonationsSortFields;
